/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{height:100%;width:100%}.regarding-text[_ngcontent-%COMP%]{width:150px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.regarding-long-text[_ngcontent-%COMP%]{white-space:normal}"];
export { styles as styles };
